// Intentional Pinia store — persists "remember me" preferences for the login screen
// to localStorage. No API calls.
import { defineStore } from "pinia";

interface LoginPrefsState {
  // Email saved when the user ticks "Remember me". `null` means cleared.
  savedEmail: string | null;
}

export const useLoginPrefsStore = defineStore({
  id: "loginPrefs",
  persist: true,

  state: (): LoginPrefsState => ({
    savedEmail: null,
  }),

  actions: {
    rememberEmail(email: string) {
      this.savedEmail = email;
    },
    forgetEmail() {
      this.savedEmail = null;
    },
  },
});
